var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimelineSeparatorBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 54,
    viewBox: "0 0 6 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 0.866667C1.82179 0.866667 0.866667 1.82179 0.866667 3C0.866667 4.17821 1.82179 5.13333 3 5.13333C4.17821 5.13333 5.13333 4.17821 5.13333 3C5.13333 1.82179 4.17821 0.866667 3 0.866667ZM2.71716 53.2828C2.87336 53.4391 3.12663 53.4391 3.28284 53.2828L5.82843 50.7373C5.98463 50.581 5.98463 50.3278 5.82843 50.1716C5.67222 50.0154 5.41895 50.0154 5.26274 50.1716L3 52.4343L0.737256 50.1716C0.581046 50.0154 0.32778 50.0154 0.171571 50.1716C0.015361 50.3278 0.015361 50.581 0.171571 50.7373L2.71716 53.2828ZM3 3L2.6 3L2.6 53L3 53L3.4 53L3.4 3L3 3Z",
    fill: "#141743"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimelineSeparatorBottom);
export default __webpack_public_path__ + "static/media/timeline-separator-bottom.7e540a650ce32d9936b9e7a2cfcac98e.svg";
export { ForwardRef as ReactComponent };